/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFollowedProjectsQueryVariables = Types.Exact<{
  limit: Types.InputMaybe<Types.Scalars['Int']>;
  offset: Types.InputMaybe<Types.Scalars['Int']>;
  sort: Types.InputMaybe<Types.Scalars['Boolean']>;
  filters: Types.InputMaybe<Types.CampaignsFilters>;
}>;


export type GetFollowedProjectsQuery = { __typename: 'Query', getCampaigns: { __typename: 'ArtistsResponse', artists: Array<{ __typename: 'Artist', name: string | null, spotify_id: string | null, facebook_id: string | null, campaigns: Array<{ __typename: 'Campaign', id: string | null, name: string | null, owner_id: number | null }> | null }> } | null };


export const GetFollowedProjectsDocument = gql`
    query getFollowedProjects($limit: Int, $offset: Int, $sort: Boolean, $filters: CampaignsFilters) {
  getCampaigns(limit: $limit, offset: $offset, sort: $sort, filters: $filters) {
    artists {
      name
      spotify_id
      facebook_id
      campaigns {
        id
        name
        owner_id
      }
    }
  }
}
    `;

/**
 * __useGetFollowedProjectsQuery__
 *
 * To run a query within a React component, call `useGetFollowedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowedProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetFollowedProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetFollowedProjectsQuery, GetFollowedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFollowedProjectsQuery, GetFollowedProjectsQueryVariables>(GetFollowedProjectsDocument, options);
      }
export function useGetFollowedProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFollowedProjectsQuery, GetFollowedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFollowedProjectsQuery, GetFollowedProjectsQueryVariables>(GetFollowedProjectsDocument, options);
        }
export type GetFollowedProjectsQueryHookResult = ReturnType<typeof useGetFollowedProjectsQuery>;
export type GetFollowedProjectsLazyQueryHookResult = ReturnType<typeof useGetFollowedProjectsLazyQuery>;